import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var NOTIFICATION_TYPES = {
  warnings: 'warnings',
  invites: 'invites',
  payments: 'payments'
};
export var NOTIFICATION_TYPES_BY_API_TYPES = _defineProperty(_defineProperty(_defineProperty({}, NOTIFICATION_TYPES.warnings, ['PassportData', 'FZ533', 'Simplification', 'UserBlock', 'Unknown', 'FinBlock', 'ReplaceSim', 'IPOE', 'AdminBlock', 'Collection', 'promisedPayment', 'Ported', 'Relocation', 'SosPackage']), NOTIFICATION_TYPES.invites, ['Invite']), NOTIFICATION_TYPES.payments, ['Pcl']);